import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">当前最受关注的话题标签，点击探索更多</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.name}
              href="#ranking"
              className={`whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 ${
                topic.heat === 'high'
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : topic.heat === 'medium'
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
              }`}
            >
              <span>{topic.name}</span>
              <span className="text-[11px] opacity-70">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}